import React from 'react';
import MultinationalTabs from '../../../../../components/MultinationalTabs/MultinationalTabs';
import { Col, Row, Input, Switch } from 'antd';
import Spacer from '../../../../../components/Spacer/Spacer';

const { TextArea } = Input;

export default function ServiceToastForm({
    data,
    onInputChange,
    onSwitchChange,
    excludedCodes,
}) {
    return (
        <div>
            <div className="form__item-wrapper">
                <p className="input-label">Show service toast</p>
                <div>
                    <Switch
                        onChange={onSwitchChange}
                        checked={data?.is_show_service_toast}
                        className="details-table__switch--general"
                    >
                        Yes
                    </Switch>
                </div>
            </div>
            <Spacer />
            <div className="form__item-wrapper">
                <Row>
                    <Col span={9}>
                        <MultinationalTabs
                            excludedCodes={excludedCodes}
                            renderWithFlag={(flag) => (
                                <TextArea
                                    name={flag}
                                    rows={7}
                                    autoSize
                                    value={
                                        data?.service_toast_translations?.[flag]
                                    }
                                    onChange={onInputChange}
                                />
                            )}
                        />
                    </Col>
                </Row>
            </div>
        </div>
    );
}
